export type RouteChangeHandler = (route: string) => void;

export class ContentTypeRouteService {
	handlers: RouteChangeHandler[];
	bufferedRoutes: string[];

	constructor() {
		this.handlers = [];
		this.bufferedRoutes = [];
	}

	dispose() {
		this.handlers = [];
		this.bufferedRoutes = [];
	}

	updateRoute(route: string) {
		if (this.handlers.length === 0) {
			this.bufferedRoutes.push(route);
		} else {
			this.handlers.forEach((handler) => handler(route));
		}
	}

	onRouteChange(cb: RouteChangeHandler) {
		this.handlers.push(cb);

		if (this.bufferedRoutes.length) {
			const latestRoute = this.bufferedRoutes[this.bufferedRoutes.length - 1];
			this.updateRoute(latestRoute);
			this.bufferedRoutes.length = 0;
		}
	}
}

export const routeService = new ContentTypeRouteService();
